import React, { useState, useEffect } from "react";
import "./typing.css";

const GREETINGS = ["Hoi!", "Hello!", "Hallo!", "Bonjour!", "Hola!"];

const Typing = () => {
  const [displayText, setDisplayText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [textIndex, setTextIndex] = useState(0);
  const [typingSpeed, setTypingSpeed] = useState(80);

  useEffect(() => {
    const handleType = () => {
      const fullText = displayText;
      const currentGreeting = GREETINGS[textIndex];

      if (!isDeleting) {
        if (fullText.length < currentGreeting.length) {
          setDisplayText(currentGreeting.substring(0, fullText.length + 1));
          setTypingSpeed(80);
        } else {
          setTypingSpeed(2000);
          setIsDeleting(true);
        }
      } else {
        if (fullText.length > 0) {
          setDisplayText(currentGreeting.substring(0, fullText.length - 1));
          setTypingSpeed(50);
        } else {
          setIsDeleting(false);
          setTextIndex((prev) => (prev + 1) % GREETINGS.length);
          setTypingSpeed(500);
        }
      }
    };

    const timer = setTimeout(handleType, typingSpeed);
    return () => clearTimeout(timer);
  }, [displayText, isDeleting, textIndex, typingSpeed]);

  return (
    <div className="typing">
      <span className="typing__text">{displayText}</span>
      <span className="typing__cursor">|</span>
    </div>
  );
};

export default Typing;
